<div class="row">

    <!-- left side -->
    <div [ngClass]="{ 'col-md-8': !fullHeader, 'col-md-12': fullHeader }">
        <div [ngClass]="setTiyleColor()">
            <h1 *ngIf="headingSize1" class="h1-responsive mb-0">
                <span>{{title}}</span>
            </h1>
            <h2 *ngIf="headingSize2" class="h2-responsive mb-0">
                <span>{{title}}</span>
            </h2>
            <h3 *ngIf="headingSize3" class="h3-responsive mb-0">
                <span>{{title}}</span>
            </h3>
            <h4 *ngIf="headingSize4" class="h4-responsive mb-0">
                <span>{{title}}</span>
            </h4>
            <h5 *ngIf="headingSize5" class="h5-responsive mb-0">
                <span>{{title}}</span>
            </h5>
            <h6 *ngIf="headingSize6" class="h6-responsive mb-0">
                <span>{{title}}</span>
            </h6>

            <small *ngIf="subTitle">
                {{subTitle}}
            </small>
        </div>
    </div>

    <!-- right side, todo... allow dynamic contact, status bits, etc. -->
    <div class="col-md-4 mt-1 mb-0" *ngIf="!fullHeader">
        <div class="row">
            <mdb-badge *ngIf="dangerText" pill="true" danger="true">{{dangerText}}</mdb-badge>
            <mdb-badge *ngIf="warningText" pill="true" warning="true">{{warningText}}</mdb-badge>
            <mdb-badge *ngIf="successText" pill="true" success="true">{{successText}}</mdb-badge>

            <div class="row align-items-center">
                <!-- Left side: Actions -->
                <div class="col text-start">
                    <ng-container *ngFor="let a of actions">
                        <a class="action-link text-primary text-decoration-underline me-2" href="javascript:void(0)"
                            (click)="actionInvokeImpl(a)">
                            {{ a.name }}
                        </a>
                    </ng-container>
                </div>

                <!-- Right side: Icons -->
                <div class="col-auto text-end">
                    <ng-container *ngFor="let i of icons">
                        <mdb-icon [fas]="true" [icon]="i.iconName" [size]="i.size" 
                            [style.color]="i.color" class="align-middle ms-2"
                            [attr.data-mdb-tooltip-init]="true" 
                            [attr.title]="i.tooltip"> &nbsp;
                        </mdb-icon>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>